import { Component, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';

import { ApiService } from '../../../services/api.service';

@Component({
  selector: 'vx-login',
  standalone: true,
  imports: [ReactiveFormsModule, RouterLink],
  template: `
    <section class="auth-shell">
      <form class="auth-card" [formGroup]="form" (ngSubmit)="submit()">
        <span class="eyebrow">Accesso sicuro</span>
        <h1>Entra in VaulTriX</h1>
        <p>Login per utenti, operatori, partner e admin.</p>
        <div class="form-field"><label>Email</label><input formControlName="email" type="email"></div>
        <div class="form-field"><label>Password</label><input formControlName="password" type="password"></div>
        @if (error()) { <strong class="error">{{ error() }}</strong> }
        <button class="btn primary" type="submit">Accedi</button>
        <a routerLink="/registrazione">Non hai un account? Registrati</a>
      </form>
    </section>
  `,
  styles: [`
    .auth-shell {
      min-height: 76vh;
      display: grid;
      place-items: center;
      padding: 70px 16px;
    }
    .auth-card {
      width: min(460px, 100%);
      display: grid;
      gap: 16px;
      padding: 30px;
      border-radius: 14px;
      background: white;
      box-shadow: var(--vx-shadow);
    }
    h1 {
      margin: 0;
      font-family: "Space Grotesk";
      font-size: 2.2rem;
    }
    p, a { color: var(--vx-muted); }
    .error { color: var(--vx-danger); }
  `]
})
export class LoginComponent {
  private readonly fb = inject(FormBuilder);
  private readonly api = inject(ApiService);
  private readonly router = inject(Router);
  protected readonly error = signal('');

  protected readonly form = this.fb.nonNullable.group({
    email: ['admin@vaultrix.io', [Validators.required, Validators.email]],
    password: ['VaulTriX123!', Validators.required]
  });

  submit() {
    if (this.form.invalid) {
      this.error.set('Inserisci email e password.');
      return;
    }
    this.api.login(this.form.value.email!, this.form.value.password!).subscribe((res) => {
      localStorage.setItem('vx_token', res.access_token);
      localStorage.setItem('vx_user', JSON.stringify(res.user));
      this.router.navigateByUrl('/dashboard');
    });
  }
}
